<template>
    <MainHeader />
    <div class="settings-header">       
    </div>
    <div class="holder">
        <h2>Användare</h2>
        <p>Lista alla användare</p>
    </div>

</template>

<script>
    import axios from 'axios';

    export default {
    }
</script>

<style>
    
</style>